// src/pages/Auth/ChangePassword.jsx
// -----------------------------------------------------------------------------
// Change password screen (Additional Requirement: POST /api/Auth/change-password).
// Collects Email, Old Password, and New Password to perform update.
// -----------------------------------------------------------------------------
import { useState } from 'react';
import { useNavigate, Link, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import authService from '../../api/authService';
import afixLogo from '../../assets/images/afix-logo.png';
import './auth.css';

export default function ChangePassword() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const initialEmail = searchParams.get('email') || '';

  const [email, setEmail] = useState(initialEmail);
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!email || !oldPassword || !newPassword) {
      setError('All fields are required.');
      return;
    }

    setSubmitting(true);
    try {
      await authService.changePassword(email, oldPassword, newPassword);
      toast.success('Password changed successfully, please login.');
      navigate('/login');
    } catch (err) {
      setError(err?.response?.data?.message || err.message || 'Password update failed.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-screen">
      {/* ---------- Left: brand panel ---------- */}
      <div className="auth-brand-panel">
        <div className="auth-blob auth-blob-1" />
        <div className="auth-blob auth-blob-2" />

        <div className="auth-brand-content">
          <img src={afixLogo} alt="AFix logo" className="auth-brand-logo" />
          <p className="auth-sub">
            Smart ticket &amp; bug tracking for teams that ship.
          </p>

          <ul className="auth-feature-list">
            <li>✓ Real-time ticket &amp; project tracking</li>
            <li>✓ Role-based dashboards for every team</li>
            <li>✓ SLA &amp; resolution insights at a glance</li>
          </ul>
        </div>
      </div>

      {/* ---------- Right: form panel ---------- */}
      <div className="auth-form-panel">
        <div className="auth-form-box">
          <img src={afixLogo} alt="AFix" className="auth-form-logo" />
          <h2>Change Password</h2>
          <p className="subtitle">Enter details below to update your login password</p>

          {error && <div className="auth-error">{error}</div>}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                id="email"
                type="email"
                placeholder="you@company.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="oldPassword">Current Password</label>
              <input
                id="oldPassword"
                type="password"
                placeholder="••••••••"
                value={oldPassword}
                onChange={(e) => setOldPassword(e.target.value)}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="newPassword">New Password</label>
              <input
                id="newPassword"
                type="password"
                placeholder="••••••••"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
              />
            </div>

            <button type="submit" className="btn btn-primary" style={{ width: '100%' }} disabled={submitting}>
              {submitting ? 'Updating...' : 'Change Password'}
            </button>
          </form>

          <div className="form-links" style={{ marginTop: '20px', textAlign: 'center' }}>
            <Link to="/login">Back to Login</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
